// Library containing some general functions, types, and interfaces.
import store from '@/store';
export const aspectIdInteraction = -1001;
export const missingValue = -9999;
export function defaultSettings() {
    return { id: '', scoreRange: { min: 1, max: 10 }, ok: false };
}
export function emptyDialogMessage() {
    return { title: '', message: '' };
}
export function nullGebruiker() {
    return { name: '', email: '', password: '', access_token: '' };
}
export function nullProject() {
    return { id: 0, name: '' };
}
export function nullScoreCard() {
    return {
        id: -1,
        project_id: -1,
        email: '',
        response_token: '',
        is_complete: false,
        data: nullDefaultSet(),
        created_at: '',
        updated_at: ''
    };
}
export function nullDataSet() {
    return { id: '?', naam: '', themas: [], maatregelen: [], aspecten: [], defaults: nullDefaultSet(), scoreletter: '', scores: [], hideInteraction: false, hideWeights: false };
}
export function nullMaatregelScore() {
    return { maatregelId: -1, answer: 0, score1to10: 0 };
}
export function nullAspectScore() {
    return { aspectId: -1, maatregelResult: [] };
}
export function nullInteractionMatrix() {
    return { size: 0, cells: [] };
}
export function nullInteractionMatrixSized(size) {
    return { size: size, cells: new Array(size * size).fill(0) };
}
function normalizeScore(maatregelScores, range, scoreDirection) {
    const min = range.min;
    const max = range.max;
    let minAnswer = 0;
    let maxAnswer = 0;
    var firstTime = true;
    for (const maatregelScore of maatregelScores) {
        if (maatregelScore.answer !== missingValue) {
            if (firstTime || maatregelScore.answer < minAnswer) {
                minAnswer = maatregelScore.answer;
            }
            if (firstTime || maatregelScore.answer > maxAnswer) {
                maxAnswer = maatregelScore.answer;
            }
            firstTime = false;
        }
    }
    const diffAnswer = maxAnswer - minAnswer;
    for (const maatregelScore of maatregelScores) {
        if (diffAnswer === 0) {
            maatregelScore.score1to10 = (min + max) / 2;
        }
        else {
            maatregelScore.score1to10 = min + (max - min) * (maatregelScore.answer - minAnswer) / diffAnswer;
            // Flip score if the scale was descending.
            if (scoreDirection === 'descending') {
                maatregelScore.score1to10 = max + min - maatregelScore.score1to10;
            }
        }
    }
}
export function scoreCardToScoreSet(scorecard, dataset, range) {
    let newScores = nullScoreSet();
    newScores.id = scorecard.email + '_' + generateHash();
    newScores.fileName = scorecard.email;
    // Interacties
    const numMaatregelen = dataset.maatregelen.length;
    for (let m = 0; m < numMaatregelen; m++) {
        let maatregelScore = nullMaatregelScore();
        maatregelScore.maatregelId = dataset.maatregelen[m].id;
        for (let m2 = 0; m2 < numMaatregelen; m2++) {
            // column values
            maatregelScore.answer += scorecard.data.interactions.cells[m + m2 * numMaatregelen];
            // rowvalues
            maatregelScore.answer += scorecard.data.interactions.cells[m * numMaatregelen + m2];
        }
        newScores.interaction.push(maatregelScore);
    }
    normalizeScore(newScores.interaction, range);
    // Aspecten
    newScores.aspectScores = scorecard.data.aspectScores.map((x) => x);
    for (let aspectScore of newScores.aspectScores) {
        const aspect = dataset.aspecten.find(aspect => aspect.id === aspectScore.aspectId);
        normalizeScore(aspectScore.maatregelResult, range, aspect?.scoreDirection);
    }
    // Gewichten
    newScores.weights = scorecard.data.aspectWeights.map((x) => x);
    const interactionWeight = scorecard.data.interactionWeight;
    newScores.weights.push({ aspectId: aspectIdInteraction, aspectWeight: interactionWeight });
    let totalWeight = 0;
    for (const thisWeight of newScores.weights) {
        totalWeight += thisWeight.aspectWeight;
    }
    // Normalize weights to 100%.
    if (totalWeight > 0) {
        const weightScaling = 100 / totalWeight;
        for (const thisWeight of newScores.weights) {
            thisWeight.aspectWeight *= weightScaling;
        }
    }
    newScores.ok = true;
    // FinalScores
    for (const maatregel of dataset.maatregelen) {
        const maatregelTotalScore = nullMaatregelScore();
        const maatregelTotalWeightedScore = nullMaatregelScore();
        maatregelTotalScore.maatregelId = maatregel.id;
        maatregelTotalWeightedScore.maatregelId = maatregel.id;
        const interactionScore = newScores.interaction.find(elem => elem.maatregelId === maatregel.id);
        const interactionWeight = newScores.weights.find(elem => elem.aspectId === aspectIdInteraction);
        if (interactionScore && interactionWeight) {
            maatregelTotalScore.score1to10 += interactionScore.score1to10 / 10;
            maatregelTotalWeightedScore.score1to10 += interactionScore.score1to10 * interactionWeight.aspectWeight / 100;
        }
        for (const aspectScore of newScores.aspectScores) {
            const maatregelScore = aspectScore.maatregelResult.find(elem => elem.maatregelId === maatregel.id);
            const weight = newScores.weights.find(elem => elem.aspectId === aspectScore.aspectId);
            if (maatregelScore && weight) {
                maatregelTotalScore.score1to10 += maatregelScore.score1to10 / 10;
                maatregelTotalWeightedScore.score1to10 += maatregelScore.score1to10 * weight.aspectWeight / 100;
            }
        }
        newScores.finalScore.push(maatregelTotalScore);
        newScores.finalWeightedScore.push(maatregelTotalWeightedScore);
    }
    return newScores;
}
export function nullScoreSet() {
    return { id: '?', fileName: '?.xlsx', interaction: [], aspectScores: [], weights: [], finalScore: [], finalWeightedScore: [], ok: false, errorMessage: '', missingData: false };
}
export function nullThema() {
    return { id: -1, naam: '', ok: false };
}
export function nullMaatregel() {
    return { id: -1, naam: '', themaId: -1, ok: false };
}
export function nullAspect() {
    return { id: -1, naam: '', uitleg: '', answerType: 'options', nrOptions: 3, labelOptions: [], labelOpen: '', scoreDirection: 'ascending', ok: false, hideAspect: false };
}
export function nullWeightEntry() {
    return { aspectId: 0, aspectWeight: 0 };
}
export function nullDefaultSet() {
    return { interactions: nullInteractionMatrix(), aspectScores: [], aspectWeights: [], interactionWeight: 0 };
}
export function generateHash() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
export function requestJson(url) {
    return new Promise((resolve, reject) => {
        store.commit('requestStart');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                store.commit('requestStop');
                try {
                    const json = JSON.parse(this.responseText);
                    resolve(json);
                }
                catch (err) {
                    reject(new Error('Failed to parse json'));
                }
            }
            else {
                store.commit('requestStop');
                reject(new Error(this.statusText));
            }
        };
        xhr.onerror = function () {
            store.commit('requestStop');
            reject(new Error(this.statusText));
        };
        xhr.send();
    });
}
